<div class="sub-navigation">
  <div class="container-fluid">
    <div class="row">
      <div class="offset-md-1 sub-navigation__left" [ngClass]="[(showArchiveSort) ? 'col-6 col-md-5' : 'col-12 col-md-10']">
        <brt-breadcrumb></brt-breadcrumb>
      </div>
      <div class="col-6 col-md-5 sub-navigation__right" *ngIf="showArchiveSort">
        <div class="sorting-dropdown">
          <div class="sorting-dropdown__label">
            {{"SORT.LABEL" | translate}}
          </div>
          <div class="sorting-dropdown__select-wrapper">
            <select #selectElement class="sorting-dropdown__select" [(ngModel)]="selectValue" (change)="onSortingChange($event)">

              <option value="name-asc">{{ "SORT.NAME_ASC" | translate }}</option>
              <option value="name-desc">{{ "SORT.NAME_DESC" | translate }}</option>

              <option *ngFor="let sortOption of sortOptions" [value]="sortOption.value" [disabled]="sortOption.disabled">{{ sortOption.label }}</option>


<!--              <option value="matching-desc">{{ "SORT.MATCHING_DESC" | translate }}</option>-->
<!--              <option value="duration-asc">{{ "SORT.DURATION_ASC" | translate }}</option>-->
<!--              <option value="duration-desc">{{ "SORT.DURATION_DESC" | translate }}</option>-->
            </select>
            <div class="sorting-dropdown__select-icon">
              <span class="icon-dropdown"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
